module.exports = __webpack_public_path__ + "img/location.d724f141.png";